
import { Link } from 'react-router-dom'; // useLocationを追加
import classes from './NavigationTop.module.scss';
import { useTranslation } from 'react-i18next';


export const NavigationTop = () => {

  const { t } = useTranslation();
  return (
    <nav className={classes.headerBar}>
      <div className={classes.hadoLogo}><Link to={t('common:header.logo_url')}><img src="https://hado-official.com/wp-content/themes/hado-official-theme/assets/img/common/logo.png"alt="Logo" /></Link></div>
      <ul className={`${classes.navMenu}`}>
      <li className={classes.navItem}><Link to={t('common:header.hado_url')}>{t('common:header.hado')}</Link></li>
        <li className={classes.navItem}><Link to={t('common:header.news_url')}> {t('common:header.news')}</Link></li>
        <li className={classes.navItem}><Link to={t('common:header.shop_url')}> {t('common:header.shop')}</Link></li>
        <li className={`${classes.navItem} ${classes.jpOnly}`}><Link to="https://hado-official.com/tournament/"> {t('common:header.tournament')}</Link></li>
        <li className={classes.navItem}><Link to={t('common:header.channel_url')}> {t('common:header.channel')}</Link></li>
        <li className={`${classes.navItem} ${classes.jpOnly}`}><Link to="https://hado-official.com/ranking/"> {t('common:header.ranking')}</Link></li>
        <li className={`${classes.navItem} ${classes.jpOnly}`}><Link to="https://hado-official.stores.jp/?category_id=6118d6392b2d3d1f50766b92"> {t('common:header.store')}</Link></li>
      </ul>
      
      
    </nav>
  );
};









